import httpService from './httpService';

export type ProcessingRequest = {
  businessId: number;
};

export type ProcessingStatus = {
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED' | 'CANCELLED' | string;
  jobId?: string;
  message?: string;
  details?: any;
};

export async function processMutations(
  body: ProcessingRequest,
): Promise<{ jobId?: string } & ProcessingStatus> {
  const { data } = await httpService.post<{ jobId?: string } & ProcessingStatus>(
    `/business/transaction-processing/process-mutations`,
    body,
  );
  return data;
}
